import * as React from "react";
import logo from "../../screens/SegmentShareApproval/logo.jpg";
import "../../screens/SegmentShareApproval/ShareApproval.css";
import axios from "../../axios";

export interface IFortellisOAuthProps {}

export function FortellisOAuth(props: IFortellisOAuthProps) {
  const handleAuth = () => {
    axios({
      method: "get",
      url: `/api/fortellis-oauth`,
    })
      .then((response) => {
        const { redirectURI } = response.data;
        console.log({ redirectURI });
        window.location.href = redirectURI;
      })
      .catch((error) => {
        alert("Something went wrong connecting to Fortellis.");
        console.log(error);
      });
  };

  return (
    <div>
      <div className="card-wrapper">
        <img src={logo} style={{ display: "block", margin: "auto" }} />

        <p style={{ fontSize: 18, marginTop: 24 }}>
          Sign-In to Fortellis to authorize CKE Tech Help to connect to your
          Fortellis Account.
        </p>

        <button
          id="success"
          className="button"
          type="button"
          onClick={() => handleAuth()}
        >
          Connect to Fortellis
        </button>
      </div>
    </div>
  );
}
